import { render } from "./ProjectResults.vue?vue&type=template&id=e484ad9c"
import script from "./ProjectResults.vue?vue&type=script&lang=js"
export * from "./ProjectResults.vue?vue&type=script&lang=js"

import "./ProjectResults.vue?vue&type=style&index=0&id=e484ad9c&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__